var map = {
	"./FutureComp-sadat/1.jpg": 12597,
	"./FutureComp-sadat/2.jpg": 86626,
	"./FutureComp-sadat/3.jpg": 97203,
	"./FutureComp-sadat/4.jpg": 90948,
	"./FutureComp-sadat/5.jpg": 47807,
	"./FutureComp-sadat/6.jpg": 17678,
	"./MiniEvent-DSA/1.JPG": 46569,
	"./MiniEvent-DSA/2.JPG": 91764,
	"./MiniEvent-DSA/3.JPG": 68328,
	"./MiniEvent-DSA/8.JPG": 44464,
	"./MiniEvent-Elsadat/1.JPG": 46579,
	"./MiniEvent-Elsadat/10.png": 94535,
	"./MiniEvent-Elsadat/11.png": 83274,
	"./MiniEvent-Elsadat/12.png": 19400,
	"./MiniEvent-Elsadat/13.png": 4382,
	"./MiniEvent-Elsadat/14.png": 18906,
	"./MiniEvent-Elsadat/15.png": 33891,
	"./MiniEvent-Elsadat/16.png": 14421,
	"./MiniEvent-Elsadat/2.png": 65821,
	"./MiniEvent-Elsadat/3.png": 54269,
	"./MiniEvent-Elsadat/4.png": 58805,
	"./MiniEvent-Elsadat/5.png": 54689,
	"./MiniEvent-Elsadat/6.JPG": 84756,
	"./MiniEvent-Elsadat/7.JPG": 21926,
	"./MiniEvent-Elsadat/8.JPG": 98199,
	"./MiniEvent-Elsadat/9.png": 42733,
	"./NationalComp/1.JPG": 89362,
	"./NationalComp/10.JPG": 48448,
	"./NationalComp/11.JPG": 41128,
	"./NationalComp/12.JPG": 92399,
	"./NationalComp/2.JPG": 69728,
	"./NationalComp/3.JPG": 8382,
	"./NationalComp/4.JPG": 25527,
	"./NationalComp/5.JPG": 31279,
	"./NationalComp/6.JPG": 70234,
	"./NationalComp/7.JPG": 74360,
	"./NationalComp/8.JPG": 20984,
	"./NationalComp/9.JPG": 29427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52013;